export default {"src":"/_next/static/image/public/images/flags/flag_976.3750a1c51836b2cc207b64f42a691c35.svg","height":16,"width":24};